import { render, staticRenderFns } from "./EmployeesSalary.vue?vue&type=template&id=1d325632&scoped=true"
import script from "./EmployeesSalary.vue?vue&type=script&lang=js"
export * from "./EmployeesSalary.vue?vue&type=script&lang=js"
import style0 from "./EmployeesSalary.vue?vue&type=style&index=0&id=1d325632&prod&scoped=true&lang=css"
import style1 from "./EmployeesSalary.vue?vue&type=style&index=1&id=1d325632&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d325632",
  null
  
)

export default component.exports